// разблокировка кнопки "далее" при выборе варианта ответа
$('body').on('change', '.answer__input', function() {
    if($('.answer__input').is(':checked')) {
        $('.btn-test-next').removeClass('btn-disabled');
    }
    else {
        $('.btn-test-next').addClass('btn-disabled');
    }
})
